import FieldTypesEnum from '../Enums/FieldTypesEnum';
import React from 'react';
import CurrencyDetailsPanel from '../Contents/Currency/CurrencyAdmin/CurrencyDetailsPanel';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import ExchangeRatePanel from '../Contents/Currency/ExchangeRate/ExchangeRatePanel';
import FigmaBadge from '../Elements/FigmaBadge';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';

export default class CurrencyAdminItem {
  constructor(item) {
    if (item === undefined) {
      this.CurrencyId = '';
      this.Code = '';
      this.Description = '';
      this.Symbol = '';
      this.IsActive = '';
      this.Status = '';
      return;
    }
    this.CurrencyId = item.currencyId;
    this.Code = item.code;
    this.Description = item.description;
    this.Symbol = item.symbol;
    this.IsActive = item.isActive;
    this.IsActive = item.isActive === true;

    this.Status = item.isActive === true ? 'Active' : 'Inactive';
  }

  static CreateEditedCurrencyJSONObject(item) {
    const convertedjson = {
      CurrencyId: item.CurrencyId.toString(),
      Code: item.Code,
      Description: item.Description,
      Symbol: item.Symbol,
      IsActive: item.IsActive.toString(),
    };

    return JSON.stringify(convertedjson);
  }

  static NameOfTheIdField() {
    return 'CurrencyId';
  }

  static nameOfTheItemDetailList() {
    return 'Currency';
  }

  static MoneyFields = [];

  static Currency() {}

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {}

  static DateFields = [];

  static BoolFields = [];

  static clickOnDetails(item) {}

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        {
          name: CurrencyAdminItem.GetCurrencyAdminDetails,
          label: '',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'General',
      tabLabel: 'Daily Exchange Rate (USD)',
      icon: 'fa-regular fa-calendar-day',
      data: [
        {
          name: CurrencyAdminItem.GetDailyExchangeRate,
          label: '',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'General',
      tabLabel: 'Monthly Exchange Rate (USD)',
      icon: 'fa-regular fa-calendar-days',
      data: [
        {
          name: CurrencyAdminItem.GetMontlyExchangeRate,
          label: '',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static editFunction = (id, user, userList) => {
    alert('editFunction');
  };

  static GetCurrencyAdminDetails(item) {
    return <CurrencyDetailsPanel CurrencyId={item.CurrencyId} />;
  }

  static GetDailyExchangeRate(item) {
    return (
      <ExchangeRatePanel
        CurrencyId={item.CurrencyId}
        Type='Daily'
      />
    );
  }

  static GetMontlyExchangeRate(item) {
    return (
      <ExchangeRatePanel
        CurrencyId={item.CurrencyId}
        Type='Monthly'
      />
    );
  }

  static getIsActiveCellContent(item) {
    return <div className='pointer'>{<FigmaBadge Active={item.IsActive} />}</div>;
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Id',
        orderById: 'CurrencyId',
        data: 'CurrencyId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 20,
      },
      { label: 'Code', orderById: 'Code', data: 'Code', minWidth: 20 },
      { label: 'Description', orderById: 'Description', data: 'Description', minWidth: 20 },
      { label: 'Symbol', orderById: 'Symbol', data: 'Symbol', minWidth: 20 },
      { label: 'Status', orderById: 'IsActive', data: CurrencyAdminItem.getIsActiveCellContent, minWidth: 20 },
      {
        label: ' ',
        orderById: '',
        data: CurrencyAdminItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        minWidth: 20,
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            onClick: () => CurrencyAdminItem.editFunction(item.CurrencyId, item),
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            roleKey: 'currencyEdit',
          },
        ]}
      />
    );
  }
}
